import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { QuoteForm } from './components/QuoteForm';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background font-sans selection:bg-accent selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <WhyChooseUs data-id="element-5" />
        <Testimonials data-id="element-6" />
        <QuoteForm data-id="element-7" />
        <CTABanner data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}